'use strict';

// vue
import Vue from 'vue/dist/vue.common.js';
import Vuex from 'vuex';

// modules
import Cookies from '../../modules/cookies';

// Vuex Modules
import databaseSearch from './modules/database-search';
import favorites from './modules/favorites';
import data from './modules/data';
import signup from './modules/signup';
import squadSearch from './modules/squad-search';

Vue.use(Vuex);

class Store {
  constructor () {
    return new Vuex.Store({
      modules: {
        databaseSearch: databaseSearch,
        favorites: favorites,
        data: data,
        signup: signup,
        squadSearch: squadSearch,
      },
      state: {
        loggedIn: Cookies.get('logged_in'),
        userName: Cookies.get('user_name'),
        csrfToken: '',
        watchVideo: false
      },
      mutations: {
        setCsrfToken(state, string) {
          state.csrfToken = string;
        },
        setWatchVideo(state, bool) {
          state.watchVideo = bool;
        }
      },
      getters: {
        userName (state) {
          return state.userName.replace('+', ' ');
        }
      }
    });
  }
}

export default new Store();



// WEBPACK FOOTER //
// ./app/javascript/vue/vuex/store.js